import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { SeatBookingData } from '../../Redux/action/seatBookingAction';
import ReactApexChart from 'react-apexcharts';
import { toast } from 'react-toastify';
import axios from 'axios';
import { dataUser } from '../Helpers/util';
import mixpanel from 'mixpanel-browser';
import AntDTable from '../Common/AntDTable/AntDTable';
import SwButton from '../Common/SwButtons/SwButtons';
import SwModal from '../Common/SwModal/SwModal';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
class SeatBookingTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: false,
      SeatList: [],
      setGroph: [],
      CheckSeatListStatus: [],

      showCancelModal: false,
      selectedIndex: null,
      /*--CityWiseBooking--*/
      series: [
        {
          name: 'Count',
          data: [],
        },
      ],

      currentPage: 1,
      pageSize: 10,
      totalRecords: 0,

      options: {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: '',
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return ' ' + val + ' ';
            },
          },
        },
      },
    };
  }

  allSeatList = (page = 1, pageSize = 10) => {
    const param = {
      company_id: UserObj.company_id,
      pgno: page,
      row: pageSize,
    };

    this.props.SeatBookingData(param);

    this.setState({
      currentPage: page,
      pageSize: pageSize,
    });
  };

  componentWillReceiveProps(props) {
    // if(props.seatgraphReducer.BookingList.data && props.seatgraphReducer.BookingList.data.graph.count){
    //   this.state.series[0].data = this.props.seatgraphReducer.BookingList.data && this.props.seatgraphReducer.BookingList.data.graph.count.map(items => parseInt(items));
    //   this.setState({
    //     ...this.state
    //   })
    // }

    if (
      props.seatgraphReducer.BookingList.data &&
      props.seatgraphReducer.BookingList.data.graph?.month
    ) {
      this.state.options.xaxis.categories =
        this.props.seatgraphReducer.BookingList.data &&
        this.props.seatgraphReducer.BookingList.data.graph?.month;
      this.setState({
        ...this.state,
      });
    }
    if (
      props.seatgraphReducer.BookingList.data &&
      props.seatgraphReducer.BookingList.data.graph?.count
    ) {
      this.state.series[0].data =
        this.props.seatgraphReducer.BookingList.data &&
        this.props.seatgraphReducer.BookingList.data.graph?.count;
      this.setState({
        ...this.state,
      });
    }

    if (props.seatBookingReducer && props.seatBookingReducer.status == 200) {
      this.setState({
        SeatList:
          (props.seatBookingReducer &&
            props.seatBookingReducer.data &&
            props.seatBookingReducer.data.list) ||
          [],
        totalRecords: props.seatBookingReducer?.data?.rows || 0,
      });
    }

    if (props.seatBookingReducer && props.seatBookingReducer.status == 200) {
      this.setState({
        CheckSeatListStatus:
          props.seatBookingReducer && props.seatBookingReducer.status,
      });
    } else {
      this.setState({
        CheckSeatListStatus:
          props.seatBookingReducer && props.seatBookingReducer.status,
      });
    }
  }

  setTabset(val) {
    // alert(val);

    this.setState({
      tab: val,
    });
  }

  clickCancelData = i => {
    this.setState({
      showCancelModal: true,
      selectedIndex: i,
    });
  };

  confirmCancelBooking = () => {
    const { selectedIndex, SeatList } = this.state;

    const params = {
      bookingId: SeatList[selectedIndex].rec_id,
      spoc_id: UserObj.rec_id,
    };

    axios
      .post(`${process.env.REACT_APP_API_URL}user/cancelFlexiBooking`, params)
      .then(response => {
        if (response.status === 200) {
          toast.success(response.data.errorMessage);
        } else {
          toast.error('Booking Not Found');
        }

        this.allSeatList();
        this.setState({ showCancelModal: false });
      })
      .catch(() => {
        toast.error('Booking Not Found');
        this.allSeatList();
        this.setState({ showCancelModal: false });
      });
  };

  seatBookingView = () => {
    mixpanel.track('Reports Seat booking analytics page view', {
      PageName: 'Seat Booking',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Seat Booking',
    });
  };

  componentDidMount() {
    this.seatBookingView();
  }

  render() {
    const columns = [
      {
        title: 'Seat No.',
        dataIndex: 'title',
        key: 'title',
        noWrap: true,
      },
      {
        title: 'Seat Category',
        dataIndex: 'category',
        key: 'category',
        noWrap: true,
      },
      {
        title: 'Location',
        dataIndex: 'location_name',
        key: 'location_name',
        noWrap: true,
        minWidth: 200, // 👈 cell custom width
      },
      {
        title: 'User Name',
        key: 'userName',
        render: (_, record) => `${record.fname} ${record.lname}`,
        noWrap: true,
        minWidth: 150, // 👈 cell custom width
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        noWrap: true,
      },
      {
        title: 'Phone',
        dataIndex: 'phone',
        key: 'phone',
        noWrap: true,
      },
      {
        title: 'Booking Date',
        dataIndex: 'booking_date',
        key: 'booking_date',
        render: date => moment(date).format('DD-MM-YYYY'),
        noWrap: true,
      },
      {
        title: 'Start Time',
        dataIndex: 'start_time',
        key: 'start_time',
        noWrap: true,
      },
      {
        title: 'End Time',
        dataIndex: 'end_time',
        key: 'end_time',
        noWrap: true,
      },
      {
        title: 'CheckIn Time',
        dataIndex: 'checkin_time',
        key: 'checkin_time',
        noWrap: true,
      },
      {
        title: 'CheckOut Time',
        dataIndex: 'checkout_time',
        key: 'checkout_time',
        noWrap: true,
      },
      {
        title: 'Amount',
        dataIndex: 'price',
        key: 'price',
        render: price => (price ? price : 0),
        noWrap: true,
      },
      {
        title: 'Status',
        key: 'status',
        render: (_, items) => {
          if (items.status == 1) return 'Booked';
          if (items.status == 2) return 'Checked In';
          if (items.status == 3 && items.checkout_time !== 'NA')
            return 'Checked Out';
          if (items.status == 3 && items.checkout_time === 'NA') return 'Ended';
          if (items.status == 4) return 'Cancelled';
          return 'Unused Booking';
        },
        noWrap: true,
      },
      {
        title: 'Action By',
        key: 'action_by',
        minWidth: 150,
        render: (_, items) =>
          items.action_by_user == 0
            ? 'SYSTEM'
            : items.action_by_user
            ? `${items.action_by_fname} ${items.action_by_lname}`
            : 'NA',
        noWrap: true,
      },
      {
        title: 'Action Time',
        dataIndex: 'action_at',
        key: 'action_at',
        render: val => val || 'NA',
        noWrap: true,
        minWidth: 150,
      },
      {
        title: 'Cancel',
        key: 'cancel',
        render: (_, record, index) =>
          record.status == 1 ? (
            <SwButton
              variant='danger-outline'
              size='sm'
              onClick={() => this.clickCancelData(index)}
              style={{ borderColor: 'red' }}
            >
              Cancel
            </SwButton>
          ) : (
            'NA'
          ),
        noWrap: true,
      },
    ];

    let setgraph = this.props.seatgraphReducer.BookingList;

    return (
      <>
        <ul className="tabs d-none">
          <li
            className={`tab-link ${!this.state.tab ? 'current' : ''}`}
            onClick={e => this.setTabset(false)}
          >
            Tabular Form
          </li>
          {/* <li
            className={`tab-link ${this.state.tab ? 'current' : ''}`}
            onClick={e => this.setTabset(true)}
          >
            Graphical Form
          </li> */}
        </ul>
        <div className="">
          <div className="">
            {this.state.tab != true ? (
              <div className={this.state.tab}>
                {this.state.CheckSeatListStatus == 200 ? (
                  <AntDTable
                    columns={columns}
                    dataSource={this.state.SeatList || []}
                    rowKey="rec_id"
                    loading={false}
                    pagination
                    currentPage={this.props.currentPage}
                    pageSize={this.props.pageSize}
                    totalRecords={this.props.totalRecords}
                    onPageChange={this.props.onPageChange}
                    clientSideSorting={false}
                    scroll={{ x: 1500 }}
                    size="small"
                  />
                ) : null}
              </div>
            ) : (
              <div className={this.state.tab}>
                <div className="pannelgraph">
                  <div className="row">
                    <div className="col-12">
                      <div className="iipannel color5">
                        <div className="iiheading">Monthly Seat Booking</div>
                        <ReactApexChart
                          options={this.state.options}
                          series={this.state.series}
                          type="bar"
                          height={250}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <SwModal
          show={this.state.showCancelModal}
          onClose={() => this.setState({ showCancelModal: false })}
          className="sw-small-modal"
          footer={
            <div className="d-flex justify-content-center align-items-center gap-3">
              <SwButton
                variant="dark-outline"
                size="sm"
                onClick={() => this.setState({ showCancelModal: false })}
              >
                Cancel
              </SwButton>

              <SwButton
                variant="primary"
                size="sm"
                onClick={this.confirmCancelBooking}
              >
                Confirm
              </SwButton>
            </div>
          }
        >
          <SwButton
            variant=""
            className="btn-close btn-close-custom"
            onClick={() => this.setState({ showCancelModal: false })}
          />

          <h3 className="SwModalSubHeading text-center">
            Are you sure you want to cancel this booking?
          </h3>
        </SwModal>
      </>
    );
  }
}

const mapStateToProps = state => ({
  seatBookingReducer: state.seatBookingReducer.BookingList,
  seatgraphReducer: state.seatBookingReducer,
});

const mapActionsToProps = {
  SeatBookingData,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(SeatBookingTable);
